const paperStyleOverrides = {
  root: {}
};
export {
  paperStyleOverrides
};
//# sourceMappingURL=styles.es.js.map
